import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const SignUpPageHelmet = () => (
  <Helmet>
    {/* SEO Title */}
    <title>Namasteji Manikchand Sign Up</title>

    {/* Meta Description  */}
    <meta
      name='description'
      content='Sign up for Namasteji Manikchand to experience India’s best pan masala. Register your account, join our community, and enjoy authentic taste with premium quality. Complete your Namasteji Manikchand registration today.'
    />

    {/* Keywords */}
    <meta
      name='keywords'
      content='Namasteji Manikchand sign up,
      Register Namasteji Manikchand account,
      Create Namasteji Manikchand account,
      Join Namasteji Manikchand,
      Namasteji Manikchand registration'
    />

    {/* Canonical URL */}
    <link rel='canonical' href='https://globalmanikchand.in/sign-up' />

    {/* Open Graph (Facebook, WhatsApp, Instagram) */}
    <meta property='og:type' content='website' />
    <meta property='og:title' content='Join Namasteji Manikchand' />
    <meta
      property='og:description'
      content='Create your Namasteji Manikchand account and become part of India’s most trusted pan masala brand. Register today to enjoy authentic blends and exclusive updates from Namasteji Manikchand.'
    />
    <meta property='og:url' content='https://globalmanikchand.in/sign-up' />
    <meta property='og:image' content={window.location.origin + manikchandLogo} />
    <meta property='og:site_name' content='Namasteji Manikchand Official' />
    <meta property='og:locale' content='en_IN' />

    {/*  Twitter Card */}
    <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:title' content='Join Namasteji Manikchand' />
    <meta
      name='twitter:description'
      content='Create your Namasteji Manikchand account and become part of India’s most trusted pan masala brand. Register today to enjoy authentic blends and exclusive updates from Namasteji Manikchand.'
    />
    <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:site' content='@NamastejiManikchand' />
  </Helmet>
);

export default SignUpPageHelmet;
